export function filterSelectBy(
  options: any,
  search: any,
  filterByProperties: any
) {
  if (filterByProperties.length === 0 || search === undefined || search === "")
    return options;
  const removeDiacritics = require("diacritics").remove;
  let searchInput = search.toLowerCase();
  searchInput = removeDiacritics(searchInput);

  const filteredOptions: any = [];
  // options filtered by search input at the start of the option label.
  const filteredOptionsByInputAtStart: any[] = [];
  // options filtered by search input inside the option label.
  const filteredOptionsByInput: any[] = [];

  options.map((option: any) => {
    return filterByProperties.map((prop: any) => {
      let optionCheck = option[prop].toLowerCase();
      optionCheck = removeDiacritics(optionCheck);

      if (
        option[prop] &&
        optionCheck.includes(searchInput) &&
        filteredOptions.indexOf(option) === -1
      ) {
        filteredOptions.push(option);
      }
    });
  });

  filteredOptions.forEach((option: any) => {
    let optionToEval = option[filterByProperties[0]].toLowerCase();
    optionToEval = removeDiacritics(optionToEval);

    if (optionToEval.indexOf(searchInput) === 0) {
      filteredOptionsByInputAtStart.push(option);
    } else {
      filteredOptionsByInput.push(option);
    }
  });

  return [...filteredOptionsByInputAtStart, ...filteredOptionsByInput];
}
